import React, { Component } from "react";
import GetStartedBtn from "./button";
import logo from "../images/logo.svg";
import "./manage.css";
import "./navbar.css";

class NavBar extends Component {
  navSlider = () => {};

  render() {
    return (
      <div className="nav-container">
        <div className="logo-container">
          <img src={logo} alt="" />
        </div>
        <div className="navbar-conatiner">
          <ul class="project-container">
            <li>
              <p>Pricing</p>
            </li>
            <li>
              <p>Product</p>
            </li>
            <li>
              <p>About Us</p>
            </li>
            <li>
              <p>Careers</p>
            </li>
            <li>
              <p>Community</p>
            </li>
          </ul>
        </div>
        <div className="navbar-container-mobile">
          <input
            type="checkbox"
            className="navigation__checkbox"
            id="navi-toggle"
          />
          <label for="navi-toggle" className="navigation__button">
            <span class="navigation__icon">&nbsp; </span>
          </label>
          <div className="navigation__background"> &nbsp; </div>
          <nav className="navigation__nav">
            <ul class="navigation__list">
              <li className="navigation__item">
                <p className="navigation__link">Pricing</p>
              </li>
              <li className="navigation__item">
                <p className="navigation__link">Product</p>
              </li>
              <li className="navigation__item">
                <p className="navigation__link">About Us</p>
              </li>
              <li className="navigation__item">
                <p className="navigation__link">Careers</p>
              </li>
              <li className="navigation__item">
                <p className="navigation__link">Community</p>
              </li>
            </ul>
          </nav>
        </div>
        <div className="button-container">
          <GetStartedBtn btn="manage-btn" />
        </div>
      </div>
    );
  }
}

export default NavBar;
